export default __webpack_public_path__ + "static/media/Home-not.5ec351d0.svg";